import { Routes } from '@angular/router'
import { strategicPricingRoutes } from './features/routes';

export const routes: Routes = [
  ...strategicPricingRoutes,
  { path: '', redirectTo: 'pricing-history', pathMatch: 'full' },
  { path: '**', redirectTo: 'pricing-history', pathMatch: 'full' },
];
